/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import style from './App.module.scss';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import {
  getUser,
  refreshToken,
  selectTokensManager,
} from 'store/auth/authSlice';
import { setToken } from 'api/Api';
import {
  ADAPTIVE_IMAGES_LIMIT,
  DESKTOP_IMAGES_LIMIT,
  getCurrentPadding,
  MIN_SCREEN_WIDTH,
} from 'utils/utils';
import { useViewport } from 'contexts/viewportContext';
import { setImagesLimit } from 'store/page/pageSlice';
import RoutesComponent from 'components/routesComponent';

const DESKTOP_GRID_WIDTH = 1200;

export default function App() {
  const dispatch = useAppDispatch();
  const tokens = useAppSelector(selectTokensManager);
  const { width } = useViewport();

  // Из за особенностей GridGallery, в алгоритм расчета размеров не должны попасть дроби
  // Иначе будут баги в компоновке. Поэтому округляем главный padding на старте и при ресайзе
  useEffect(() => {
    const isAdaptiveModeOn = width <= MIN_SCREEN_WIDTH;
    const initCSSVariables = () => {
      const padding = getCurrentPadding(isAdaptiveModeOn, width);

      document.documentElement.style.setProperty('--w-padding', `${padding}px`);

      if (isAdaptiveModeOn) {
        const gridWidth = width - padding * 2;
        document.documentElement.style.setProperty(
          '--grid-width',
          `${gridWidth}px`
        );
      } else {
        document.documentElement.style.setProperty(
          '--grid-width',
          `${DESKTOP_GRID_WIDTH}px`
        );
      }
    };

    isAdaptiveModeOn
      ? dispatch(setImagesLimit(ADAPTIVE_IMAGES_LIMIT))
      : dispatch(setImagesLimit(DESKTOP_IMAGES_LIMIT));

    initCSSVariables();
  }, [width]);

  useEffect(() => {
    if (tokens.isValidTokens) {
      if (tokens.isNeedRefresh) {
        dispatch(refreshToken(null));
      } else {
        setToken(tokens.accessToken || '');
        dispatch(getUser(null));
      }
    }

    const interval = setInterval(() => {
      if (tokens.isNeedRefresh) {
        dispatch(refreshToken(null));
      }
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, [tokens, tokens.isNeedRefresh, tokens.isValidTokens]);

  return (
    <div className={style.container}>
      <Router>
        <RoutesComponent></RoutesComponent>
      </Router>
    </div>
  );
}
